/**
 * Root Sagas
 */
import { all } from 'redux-saga/effects';

// sagas
import authSagas from './Auth';
import errorsSagas from './Errors';

export default function* rootSaga(getState) {
    yield all([
        authSagas(),
        errorsSagas()
    ]);
}